/**
 * Created by Jerker Nord on 2020-05-26.
 */
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {MonkeysGoldLogo} from "../../logo/MonkeysGoldLogo";
import {MonkeysGoldFreeSpinIntroView} from "./MonkeysGoldFreeSpinIntroView";

export class MonkeysGoldFreeSpinIntroController extends FreespinIntroController {

    private _fsWon:number = 0;
    private static _isRestoreState:boolean;
    private _fsMultiplierIncrease:number;

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:MonkeysGoldParsedGameData):boolean {
        MonkeysGoldFreeSpinIntroController._isRestoreState = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        this._isRestoreFreespin = MonkeysGoldFreeSpinIntroController._isRestoreState && data.freespinsLeft > 0;
        if((data.mode == GameMode.NORMAL || data.mode == GameMode.NORMAL_AVALANCHE) && (data.nextMode == GameMode.FREESPIN || data.nextMode == GameMode.FREESPIN_AVALANCHE)) {
            this._isFreespinWon = true;
        } else {
            this._isFreespinWon = false;
        }
        this._remainingFreeSpins = data.freespinsLeft;
        this._fsWon = data.freespinsLeft;
        this._fsMultiplierIncrease = data.fsMultiplierIncrease;
        return this._isFreespinWon || this._isRestoreFreespin;
    }

    public start() {
        (<MonkeysGoldFreeSpinIntroView>this._view).fsWon = this._fsWon;
        let startDelay:TimelineLite = new TimelineLite({delay : 1});
        startDelay.add(() => super.start());
    }

    protected close():void {
        (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.CONTINUE_BUTTON)});

        for(let i:number = 0; i < MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC.length; i++) {
            (<INolimitAudioPlayer>SlotGame.sound).fadeTrack({
                name : MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC[i],
                duration : 1,
                from : 0,
                to : 0
            });
        }
        (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : MonkeysGoldSoundConfig.instance.BONUS_GAME_MUSIC});

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }

        super.close();
    }

    protected show():boolean {
        if(this.shouldShow()) {
            this._view.show(this._serverData!, () => this.onShowComplete());
            this.hideKeypad();
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
            this._isShowing = true;
        } else {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : MonkeysGoldSoundConfig.instance.BONUS_GAME_MUSIC});
        }

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }
        SlotGame.keypad.setZeroBetSpinCounter(this._remainingFreeSpins);
        return this._isFreespinWon;
    }

    protected hideKeypad() {
        SlotGame.keypad.hide();
    }

    protected onCloseComplete():void {
        SlotGame.keypad.show();

        EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));

        MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.cleanUp();
        MonkeysGoldGameModuleConfig.monkeysGoldRowLockView.resetAllAnimations();

        if(this.shouldShow() == true && this._isRestoreFreespin == false) {
            MonkeysGoldGameModuleConfig.monkeysGoldAllReelsFilledWinView.getBonusGameDiceAnimationTL(this._fsMultiplierIncrease);
        } else {
            //Gets here if its restore into Fs intro or just restore into FS
            if(this._isRestoreFreespin == true && this.shouldShow() == true) {
                //We don't need to set the multiplier values since it was set by itself on restore
                MonkeysGoldGameModuleConfig.monkeysGoldBonusGameMultiplierView.enableMultplier();
                MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.endBottomFire();
            }
            EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED));
        }
    }

    public static actuallyDoTransition() {
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : GameMode.FREESPIN}));
        MonkeysGoldGameModuleConfig.monkeysGoldBonusGameMultiplierView.enableMultplier();
        MonkeysGoldLogo.monkeysGoldLogo.enableBonusGameLogo();
        for(let i:number = 0; i < 6; i++) {
            MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.cleanUp(i);
        }
        MonkeysGoldGameModuleConfig.monkeysGoldReelAreaView.enableBonusGameBackgroundGFX();
    }
}